export enum ENV_NAMES {
  STAGING = "staging",
  QA = "qa",
  DEV = "development",
  PROD = "production",
  TEST = "test",
}
type BackendDomains = "fantasygames" | "fantasygames1" | "fantasygames2";
type APIHostnames = `https://${BackendDomains}.nascar.com`;

const { PROD, QA, DEV, TEST } = ENV_NAMES;
const APP_ENV = process.env.NEXT_PUBLIC_APP_ENV ?? DEV;
const GAME_UID = "playoffs";

const SENTRY_DSN = [`${DEV}`, `${TEST}`].includes(APP_ENV)
  ? ""
  : "https://6a7c9c9a04314b068d6cbc3eb83a19f8@sentry.eks-demo.shub.fish/332";

const GIGYA_API_KEY: string =
  APP_ENV === PROD
    ? "3_DTbmqJY1xpGMTOjyedqctT8DDWeGfwqzYOgtGGn2M-lx-hmv2NmaoMz3dsftVnHv"
    : "3_-PwX21np3pu5LKBMms85dP4E3IfWQkLQxcJmyB84J-RvgBywIayS2IPE1lViHUjd";

const BACKEND_PREFIX: BackendDomains = `fantasygames${
  APP_ENV === PROD ? "" : APP_ENV === QA ? "2" : "1"
}`;

const COOKIE_NAMES = {
  nativeTokenCookieName: "native-account",
  localAnnouncements: "liveAnnouncements",
};

const API_BACKEND_HOSTNAME: APIHostnames = `https://${BACKEND_PREFIX}.nascar.com`;

export default {
  APP_ENV,
  GAME_UID,
  API_BACKEND_HOSTNAME,
  GIGYA_API_KEY,
  SENTRY_DSN,
  COOKIE_NAMES,
};
